export default {
  sections: {
    settings: 'Setări',
  },
  status_switch: {
    label: 'Program de loialitate',
    on: 'Activat',
    off: 'Dezactivat',
    description: 'Clienții primesc cashback la fiecare comandă și îl pot folosi la finalizarea comenzii.',
    description_missing: 'Salvează setările de mai jos pentru a-ți începe programul de loialitate.',
  },
  alerts: {
    off: 'Programul tău de loialitate este dezactivat. Clienții nu primesc cashback pentru comenzile noi, nu își pot folosi punctele și nu văd programul în magazinul tău. Punctele deja acumulate sunt păstrate și expiră ca de obicei.',
    expired: 'Programul tău de loialitate s-a încheiat. Activează-l pentru a-l reporni fără dată de final.',
  },
  form: {
    title: {
      label: 'Titlu',
    },
    percentage: {
      label: 'Procent cashback',
      validation: {
        required: 'Procentul cashback este obligatoriu',
        min: 'Valoarea minimă a procentului cashback este {{value}}%',
        max: 'Valoarea maximă a procentului cashback este {{value}}%',
      },
    },
    point_lifetime: {
      label: 'Câte zile doriți să oferiți clienților pentru a utiliza punctele?',
      validation: {
        min: 'Minimum {{value}} zile pentru expirarea punctelor',
      },
    },
    min_spending_limit: {
      label: 'Limită minimă de cheltuieli pentru cashback',
      validation: {
        required: 'Limita minimă de cheltuieli este obligatorie',
        gt_zero: 'Limita minimă de cheltuieli trebuie să fie mai mare decât 0',
        lt_max_spending_limit: 'Limita minimă de cheltuieli trebuie să fie mai mică decât limita maximă',
      },
    },
    max_spending_limit: {
      label: 'Limită maximă de cheltuieli pentru cashback',
      validation: {
        required: 'Limita maximă de cheltuieli este obligatorie',
        gt_min_spending_limit: 'Limita maximă de cheltuieli trebuie să fie mai mare decât limita minimă',
      },
    },
    has_welcome_bonus: {
      label: 'Bonus de bun venit',
      description: 'Oferiți clienților la prima vizită un bonus cashback la înregistrare',
    },
    welcome_bonus: {
      label: 'Valoarea bonusului de bun venit',
    },
    has_end_date: {
      label: 'Durată',
      options: {
        false: 'Nelimitată',
        true: 'Cu dată de încheiere specifică',
      },
    },
    end_date: {
      label: 'Dată de încheiere',
    },
    has_mobile_app_signup_bonus: {
      label: 'Bonus la înregistrare în aplicația mobilă',
      description: 'Recompensați utilizatorii care se conectează prin aplicația mobilă pentru prima dată',
    },
    mobile_app_signup_bonus: {
      label: 'Valoarea bonusului',
    },
  },
  tags: {
    inactive: 'Inactiv',
    active: 'Activ',
    expired: 'Expirat',
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    changes_got_saved: 'Modificările au fost salvate',
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    turned_on: 'Program de loialitate activat',
    turned_off: 'Program de loialitate dezactivat',
  },
};
